import { Alert } from '@utilitywarehouse/hearth-react';

import './styles.scss';

const EACAlert = () => (
  <Alert colorScheme="info" className="eacAlert">
    The industry estimates above are based on the information we've received
    from your property's energy meters. You can edit them if you believe they're
    incorrect.
  </Alert>
);

export { EACAlert };
